const cellNames = {
  users: ["ردیف", "نام", "نام خانوادگی", "شماره تلفن"],
  user_financial: [
    "ردیف",
    "عنوان",
    "مبلغ (ریال)",
    "روش پرداخت",
    "شناسه چک",
    "شماره رسید",
    "وضعیت",
    "تاریخ",
    "تاریخ پرداخت",
  ],
  user_attendance: [
    "ردیف",
    "نام کلاس",
    "نام درس",
    "سال تحصیلی",
    "وضعیت",
    "تاریخ",
  ],
  user_class: [
    "ردیف",
    "نام کلاس",
    "نوع کلاس",
    "نام درس",
    "نام مدرس",
    "سال تحصیلی",
    "مقطع تحصیلی",
    "پایه تحصیلی",
    "فایل ها",
  ],
  class_file: ["ردیف", "عنوان", "توسط", "سال تحصیلی", "تاریخ", "دانلود"],
  user_score: [
    "ردیف",
    "نام کلاس",
    "نام درس",
    "نام مدرس",
    "نمره",
    "سال تحصیلی",
    "تاریخ",
  ],
  //////////////////////////// teacher /////////////////////
  teacher_financial: [
    "ردیف",
    "مبلغ (ریال)",
    "شماره رسید",
    "وضعیت",
    "سال تحصیلی",
    "تاریخ",
    "رسید پرداخت",
  ],
  teacher_class_file: [
    "ردیف",
    "عنوان",
    "توسط",
    "سال تحصیلی",
    "تاریخ",
    "دانلود",
    "ویرایش",
  ],
  teacher_class: [
    "ردیف",
    "نام کلاس",
    "نوع کلاس",
    "نام درس",
    "سهم مدرس",
    "سال تحصیلی",
    "مقطع تحصیلی",
    "پایه تحصیلی",
    "حضور غیاب",
    "لیست نمرات",
    "آزمون تستی",
    "فایل ها",
  ],
  teacher_user_attendance: [
    "ردیف",
    "نام و نام خانوادگی",
    "پایه",
    "کد ملی",
    "وضعیت",
  ],
  teacher_attendance: ["ردیف", "عنوان", "تاریخ", "پایه", "سال تحصیلی"],
  teacher_class_scores_list: [
    "ردیف",
    "تاریخ",
    "نام درس",
    "توسط",
    "ویرایش",
    "حذف",
  ],
  message_user_list: [
    "ردیف",
    "نام و نام خانوادگی",
    "نام پدر",
    "کد ملی",
    "مقطع تحصیلی",
    "پایه",
    "شماره تماس",
  ],
  excellScores_list: ["ردیف", "عنوان", "تاریخ", "نمرات"],
  excellScores_view_list: [
    "ردیف",
    "نام و نام خانوادگی",
    "نمره",
    "نمره خام",
    "رتبه",
    "درست",
    "نزده",
    "غلط",
  ],
  excellScores_view_list_student: [
    "ردیف",
    "عنوان",
    "نمره",
    "نمره خام",
    "رتبه",
    "درست",
    "نزده",
    "غلط",
  ],
  exam_score_list: [
    "ردیف",
    "تاریخ",
    "نوع پاسخنامه",
    "تعداد سوال",
    "نمرات",
    "پاسخنامه",
    "وضعیت",
  ],
  testScores_view_list: [
    "ردیف",
    "نام و نام خانوادگی",
    "نمره (درصد)",
    // "نمره خام",
    "رتبه",
    "درست",
    "نزده",
    "غلط",
    "پاسخنامه",
    "پاسخ ها",
  ],
  testScores_view_list_user: [
    "ردیف",
    "نام کلاس",
    "نمره (درصد)",
    // "نمره خام",
    "رتبه",
    "درست",
    "نزده",
    "غلط",
    "پاسخنامه",
  ],
  user_c_exam_score_list: ["ردیف", "تاریخ", "پایه", "رشته", "کارنامه"],
};

export default function generateHeadCells(pageName) {
  return cellNames[pageName].map((items, index) => ({
    id: `${pageName} headCell ${index}`,
    numeric: false,
    disableadding: false,
    label: items,
  }));
}
